import { render, staticRenderFns } from "./cadpedidoscompra.vue?vue&type=template&id=12a4f6d3&"
import script from "./cadpedidoscompra.vue?vue&type=script&lang=js&"
export * from "./cadpedidoscompra.vue?vue&type=script&lang=js&"
import style0 from "./cadpedidoscompra.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports